import Store from '@/store/computed/storeHelpers'
export default {
  computed: {
    defaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'tippingDefaultHeaders'
    })
  },
  data() {
    return {
      allPossibleHeaders: [
        {
          text: 'ID',
          align: 'left',
          value: 'id',
          type: 'text'
        },
        {
          text: 'Reference',
          align: 'left',
          value: 'tippingDocketHeader.externalRef',
          type: 'text'
        },
        {
          text: 'Date',
          align: 'left',
          value: 'tippingDocketHeader.date',
          type: 'date'
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status',
          type: 'text'
        },
        {
          text: 'Project',
          align: 'left',
          value: 'tippingDocketHeader.project.name',
          type: 'text'
        },
        {
          text: 'W/B Docket #',
          align: 'left',
          value: 'wbDocketNumber',
          type: 'text'
        },
        {
          text: 'Spoil',
          align: 'left',
          value: 'spoil.name',
          type: 'text'
        },
        {
          text: 'Tip',
          align: 'left',
          value: 'tippingDocketHeader.tip.name',
          type: 'text'
        },
        {
          text: 'Sub-Contractor',
          align: 'left',
          value: 'tippingDocketHeader.vehicle.contractor.name',
          type: 'text'
        },
        {
          text: 'Vehicle',
          align: 'left',
          value: 'tippingDocketHeader.vehicle.name',
          type: 'text'
        },
        {
          text: 'Vehicle Type',
          align: 'left',
          value: 'tippingDocketHeader.vehicle.vehicleType.name',
          type: 'text'
        },
        {
          text: 'VIN',
          align: 'left',
          value: 'tippingDocketHeader.vehicle.vin',
          type: 'text'
        },
        {
          text: 'Qty',
          align: 'left',
          value: 'qty',
          type: 'num',
          decimals: 2
        },
        {
          text: 'Cost Price',
          value: 'costPrice',
          align: 'right',
          type: 'curr',
          decimals: 2
        },
        {
          text: 'Cost Total',
          value: 'costTotal',
          align: 'right',
          type: 'curr',
          decimals: 2
        },
        {
          text: 'Day / Night',
          align: 'center',
          value: 'tippingDocketHeader.isDay',
          type: 'dayBool'
        },
        {
          text: 'Notes',
          align: 'center',
          value: 'notes',
          type: 'text'
        },
        {
          text: 'Created At',
          align: 'left',
          value: 'createdAt',
          type: 'date'
        },
        {
          text: 'Updated At',
          align: 'left',
          value: 'updatedAt',
          type: 'date'
        },
        {
          text: 'Created By',
          align: 'left',
          value: 'createdBy.name',
          type: 'text'
        },
        {
          text: 'Updated By',
          align: 'left',
          value: 'updatedBy.name',
          type: 'text'
        }
      ]
    }
  }
}
